module.exports = __webpack_public_path__ + "img/icon-mytarget-graph.03864cd2.svg";